import { AnyAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import useDeepCompareCallback from 'hooks/useDeepCompareCallback'

export function useAction<T = unknown>(
    action: (payload: T) => AnyAction
): (payload?: T) => AnyAction {
    const dispatch = useDispatch()

    return useDeepCompareCallback(
        (payload?: T) => bindActionCreators(action, dispatch)(payload as T),
        [action, dispatch]
    )
}
